import {Col, Image, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function Banner({ type }) {

    const { t } = useTranslation(); // Use t instead of lang

    return (
        <div className='banner bg-banner my-4'>
            <Row className='align-items-center justify-content-center gap-2'>
                <Col sm={5}>
                    <Image alt="image"   src='/images/banner.png' className='img-fluid'/>
                </Col>
                <Col sm={5}>
                <h3>{t("admin_title")} <Image alt="image"   src='/images/fire.png'/></h3>
                <p>{t("network_troubleshooting_message")}</p>
                {/* <Button aria-label="Aria label" className='btn-orange'>{t("View All")}</Button> */}
                </Col>

            </Row>
        </div>
    );
}

export default Banner;